import { LeagueParticipant } from '../../domain/models';

export interface LeagueParticipantEntity {
  id: string;
  league_id: string;
  name: string;
  user_id: string | null;
  created_at: string;
}

// Mapper: de Entity (DB) a Model (Domain)
export const leagueParticipantEntityToModel = (entity: LeagueParticipantEntity): LeagueParticipant => {
  return {
    id: entity.id,
    leagueId: entity.league_id,
    name: entity.name,
    userId: entity.user_id || undefined,
    createdAt: new Date(entity.created_at),
  };
};
